import DocShell, { Clause } from '@/components/rack/DocShell';

/**
 * 隐私政策。
 *
 * 上一版是从模板抄来的通用条款：主语是「我们」，品牌还是旧的「脑洞有AI」，
 * 还写着「通过 Cookie 和类似技术自动收集使用数据」——而这站根本没接统计脚本。
 * 写不存在的收集行为，比不写更糟：真有人拿这页对着源码看，会发现对不上。
 * 所以这版按实际情况重写，主语换成阳仔AI。
 */
export default function PrivacyPolicy() {
  return (
    <DocShell
      code="PRIVACY"
      title="隐私政策"
      updated="2026-09-01"
      thesis="不收集的东西，不用保护"
      lede="这站是纯静态页面：没有账号、没有表单、没有埋点统计。所以这份政策很短——多数条款讲的是「没有做什么」，剩下的是你主动联系我之后，你给我的信息我怎么用。"
      description="阳仔AI（minddock.ai）隐私政策：站点不设账号与埋点统计，仅在你主动联系时获得你提供的信息；客户项目数据归客户，按最小必要访问。"
      path="/privacy"
    >
      <div className="mt-4 border-t border-rack-bone/12">
        <Clause no="§01" title="谁在处理你的信息">
          <p>
            minddock.ai 由阳仔AI 个人运营——一个独立开发者，没有团队，也没有数据部门。
            这页里的「我」就是这个人。
          </p>
        </Clause>

        <Clause no="§02" title="浏览这个站">
          <p>
            站点是静态页面，没有登录、没有注册、没有表单，也没有接入任何统计或埋点脚本。
            你只是看看的话，我这边拿不到任何关于你的信息。
          </p>
          <p>
            站点托管在 Cloudflare。托管商出于安全与可用性会记录访问日志（IP、浏览器标识、访问时间），
            这部分由 Cloudflare 保管并按其自身政策处理；我不导出、不做用户画像、不用于广告投放。
          </p>
        </Clause>

        <Clause no="§03" title="你主动给我的信息">
          <p>
            加微信或发邮件时，你告诉我的那些：联系方式、需求描述、你发来的材料。
            这些只用于回复你、判断能不能做、以及推进这件事本身。
          </p>
          <p>不卖给第三方，不拿去换资源，也不会用来给你发无关的推广。</p>
        </Clause>

        <Clause no="§04" title="合作项目里的数据">
          <p>
            如果我们真的合作：项目里的数据归你。我按最小必要访问——能在你自己的环境里跑的，
            就不往外拷；需要样本调试的，用脱敏样本。
          </p>
          <p>
            项目结束后我删除本地副本，或按合同约定处理。涉及敏感数据的项目可以另签保密协议，
            以协议约定优先于这一页。
          </p>
        </Clause>

        <Clause no="§05" title="第三方与站外链接">
          <p>
            本站不放广告，不接第三方追踪脚本。站上链接到的外部站点（App Store、GitHub、
            各产品自己的域名等）有各自的隐私政策，那部分不由我控制。
          </p>
          <p>
            我发布的 App 各有自己的隐私政策，以应用内或其商店页面给出的版本为准，不由这一页覆盖。
          </p>
        </Clause>

        <Clause no="§06" title="未成年人">
          <p>
            本站面向企业客户与开发者，不面向儿童，也不会主动收集未满 14 周岁未成年人的个人信息。
          </p>
        </Clause>

        <Clause no="§07" title="你的权利">
          <p>
            想知道我这里有没有你的信息、想让我删掉、或者想更正某一项，发邮件说一声就行。
            没有工单系统，是我本人处理，一周内给你回复。
          </p>
        </Clause>

        <Clause no="§08" title="这页会变">
          <p>
            政策变了我会改这一页并更新顶部的日期。如果以后接入了统计或其它会收集数据的东西，
            我会先在这里写清楚用的是什么、收什么。
          </p>
        </Clause>
      </div>
    </DocShell>
  );
}
